module.exports = __webpack_public_path__ + "static/media/CMA.02dfecfb.jpeg";